<template>
	<div style="display: flex; flex-flow: column;">
		<SearchBar/>
		<SearchResults/>
	</div>
</template>

<script>
import SearchBar from '@/components/search/SearchBar.vue';
import SearchResults from '@/components/search/SearchResults.vue';

export default {
	components: {
		SearchBar, SearchResults
	}
}
</script>